<div *ngIf="pages?.length > 0" class="show-more-container" cdkDragBoundary="app-elite-form-response-container"
     id="dragableCompColumn" cdkDrag>
    <div *ngIf="showPageOptions" class="paginations">
        <div class="page-options">
            <div class="page-option" title="{{i + 1}}. {{ page.title }}"
                 [ngClass]="{ active: formResponseViewService.currentPageIndex == i }"
                 [attr.id]="i+1"
                 *ngFor="let page of pages;let i = index" (click)="goToPage(i)">
                <a>{{i + 1}}. {{ page.title }}</a>
            </div>
        </div>
    </div>

    <div class="wrappers">
        <div class="links flex flex-row justify-start items-center">
            <a title="Previous Page" [ngClass]="{disable: formResponseViewService.currentPageIndex === 0 }"
               class="show-more"
               (click)="goToPreviousPage()">
                <i class="fa-solid fa-arrow-left"></i>
            </a>
            <div (click)="onTogglePagination()" class="page-info flex flex-row justify-center items-center">
                <div>
                <span class="page-indicator">Page {{formResponseViewService.currentPageIndex + 1}} of
                    {{pages.length}}</span>
                    <i *ngIf="!showPageOptions" class="fa-regular fa-chevron-up"></i>
                    <i *ngIf="showPageOptions" class="fa-regular fa-chevron-down"></i>
                </div>
            </div>
            <a title="Next Page" [ngClass]="{disable:formResponseViewService.currentPageIndex === pages.length - 1}"
               class="show-more"
               (click)="goToNextPage()">
                <i class="fa-solid fa-arrow-right"></i>
            </a>

        </div>
        <div class="additional-buttons">
            <button *ngIf="pages[formResponseViewService.currentPageIndex]?.fieldValues?.['IsLastPage'] && !isReadOnly"
                    mat-button
                    (click)="addMultipleResponsePage(pages[formResponseViewService.currentPageIndex]?.fieldValues?.['AddNewPageResponseCommand'] ,formResponseViewService.currentPageIndex)">
                <i class="fa-regular fa-plus"></i> Add Response
            </button>
            <button *ngIf="!isReadOnly && pages[formResponseViewService.currentPageIndex]?.fieldValues?.['IsMultiResponsePage'] && !isDeleteButtonDisabled"
                    mat-button
                    matTooltip="Delete Page Response"
                    (click)="deleteMultipleResponsePage(formResponseViewService.currentPageIndex)">
                <i class="fa-regular fa-trash"></i>
            </button>
        </div>
    </div>
</div>


<div class="wrapper">
    <div id="graphCanvasRef" class="graph-component" *ngIf="platformDialogsByPage">
        <app-elite-form-single-page-response *ngIf="pages.length > 0 && formResponseViewService.currentPageIndex >= 0"
                                             [itemId]="itemId"
                                             [platformDialog]="platformDialogsByPage[pages[formResponseViewService.currentPageIndex].id]"
                                             [pageModel]="pages[formResponseViewService.currentPageIndex]"
                                             [totalPageCount]="pages.length"
                                             [inputForm]="inputForm" (fieldValueChange)="onFieldValueChange($event)"
                                             (sectionIncluded)="onSectionIncluded()">
        </app-elite-form-single-page-response>
        <!-- <div class="form-footer flex flex-row justify-between items-center">
            <button mat-button class="mat-flat-button orbitax-footer-button" [disabled]="currentPageIndex === 0"
                (click)="goToPreviousPage()">Previous</button>
            <span class="page-indicator">Page {{currentPageIndex + 1}} of {{pages.length}}</span>
            <button mat-flat-button class="orbitax-footer-action-button" type="button" color="accent"
                [disabled]="currentPageIndex === pages.length - 1" (click)="goToNextPage()">
                Next
            </button>
        </div> -->
    </div>
</div>
